import { useTranslation } from "react-i18next";
import Logo from "./logo.svg";

function MainLogo() {
  const { t } = useTranslation();
  return (
    <div className="mb-10 md:mb-14 text-center">
      {/* Logo */}
      <div style={{ animation: "logoImg 0.5s cubic-bezier(0.22,1,0.36,1) 0.05s both" }}>
        <img
          src={Logo}
          alt={t("mainLogo.logoAlt")}
          className="mx-auto w-24 md:w-40"
        />
      </div>

      {/* Title */}
      <h1
        className="mt-7 text-[clamp(2rem,5vw,4.5rem)] font-extralight text-mainDark tracking-tight leading-[1.08] max-w-2xl mx-auto"
        style={{ animation: "logoTitle 0.55s cubic-bezier(0.22,1,0.36,1) 0.1s both" }}
      >
        {t("mainLogo.title")}
      </h1>

      <style>{`
        @keyframes logoImg {
          from { opacity: 0; transform: translateY(12px) scale(0.96); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes logoTitle {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default MainLogo;
